import { render, staticRenderFns } from "./ZoomFab.vue?vue&type=template&id=32401a3a&lang=pug&"
import script from "./ZoomFab.vue?vue&type=script&lang=js&"
export * from "./ZoomFab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ZoomFab.vue"
export default component.exports